import { Module } from "vuex";
import { RefreshGridMode, PhonePopupData } from "@/models/leads/Lead";
import { LeadsState } from "@/models/states/LeadsState";
import { RootState } from "@/models/states/RootState";
import actions from "./actions";
import getters from "./getters";
import mutations from "./mutations";

export const getDefaultState = () => {
  return {
    deactivateStats: false,
    graphsHiddenOnScroll: false,
    clientsSearchValue: "",
    clientsSelectedPriceType: "0",
    leadsLoading: false,
    needToRefreshLeadsGrid: RefreshGridMode.None,
    page: 1,
    searchValue: "",
    selectedClientId: 0,
    selectedPriceType: "0",
    showDeleted: false,
    showDeletedClientLeads: false,
    showFavourite: false,
    showFavouriteClientLeads: false,
    showGraphs: true,
    showGraphsClientLeads: true,
    showNotActiveCampaign: true,
    showNotActiveCampaignClientLeads: true,
    sortDir: "desc",
    sortField: "CreateDate",
    uniqueByCampaign: false,
    uniqueByCampaignClientLeads: false,
    columnsFilters: undefined,
    leads: {},
    leadsCancelTokenSource: undefined,
    clientEditViewModel: undefined,
    leadEditViewModel: undefined,
    leadsPageData: undefined,
    leadsPayload: undefined,
    leadsStatisticPhones: undefined,
    selectedLead: undefined,
    selectedClient: undefined,
    tableSettings: undefined,
    adGroups: [],
    adTitles: [],
    additionalStatuses: [],
    assets: [],
    assignees: [],
    channels: [],
    companies: [],
    columns: [],
    commitments: [],
    processes: [],
    selectedProcessesIds: [],
    clientsSelectedProcessesIds: [],
    datePeriod: [],
    clientsDatePeriod: [],
    clientsSelectedAdditionalStatusesIds: [],
    clientsSelectedAdGroupsIds: [],
    clientsSelectedAdTitles: [],
    clientsSelectedAssetsIds: [],
    clientsSelectedAssigneesIds: [],
    clientsSelectedCallStatusesIds: [],
    clientsSelectedChannelMetadataTypesIds: [],
    clientsSelectedChannelsIds: [],
    clientsSelectedCompaniesIds: [],
    clientsSelectedCommitmentsIds: [],
    clientsSelectedFoundMetadataTypesIds: [],
    clientsSelectedLeadGridColumnsIds: [],
    clientsSelectedLeadStatusesIds: [],
    clientsSelectedSaleStatusesIds: [],
    clientsSelectedTags: [],
    leadsStatisticByAdditionalStatus: [],
    leadsStatisticByCallStatus: [],
    leadsStatisticByCampaigns: [],
    leadsStatisticByPhoneAndForms: [],
    leadsStatisticBySaleStatus: [],
    leadsStatisticChannelMetadataType: [],
    leadsStatisticDealMeetingsLeads: [],
    selectedAdditionalStatusesIds: [],
    selectedAdGroupsIds: [],
    selectedAdTitles: [],
    selectedAssetsIds: [],
    selectedAssigneesIds: [],
    selectedCallStatusesIds: [],
    selectedChannelMetadataTypesIds: [],
    selectedChannelsIds: [],
    selectedCompaniesIds: [],
    selectedCommitmentsIds: [],
    selectedFoundMetadataTypesIds: [],
    selectedLeadGridColumnsIds: [],
    selectedLeadStatusesIds: [],
    selectedSaleStatusesIds: [],
    selectedTags: [],
    tags: [],
    phonePopupData: {
        showPopup: false,
        message: "",
    } as PhonePopupData,
  };
}

const leadsModule: Module<LeadsState, RootState> = {
  namespaced: true,
  state: getDefaultState(),
  getters,
  mutations,
  actions,
};
export default leadsModule;
